module.exports = __webpack_public_path__ + "static/media/home-banner.d8a57aaf.jpg";